<template>
  <div>
    <div class="title">
      <div id="notice">
        <h5>物流管理ERP帮助&nbsp;使用说明:<br>
         
          	<span>1、标题、描述、自定义详情页 </span><br>
          	<span>2、</span><br>
          	<span>3、</span><br>
        </h5>
      </div>
    </div>

    <pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

    </pre-base>

  </div>
</template>

<script>
  import api from '@/utils/type.js';
  import {
    Method_EasySelect,
    Method_SelColumn
  } from '@/utils/loadhttpdata.js';

  // import {
  //   BackSpecial
  // } from "@/utils/localstore.js";

  import {
    base_decode
  } from "@/utils/base64.js";

  export default {
    components: {
      "pre-base": () => import("../auto/page_build.vue")
    },
    data() {
      return {
        check_key: '',
        init_data: '',
		
        row_id: '',
        item: ''

      };
    },
    mounted: function() {
      // 保证首次加载完成时运行
      console.log('加载。。。');
      // this.init_view();
    },
    created: function() {
      //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，属性和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，$el 属性目前不可见。
      console.log(' 自动构建 创建'); //发起ajax请求
      this.fun_init();
    },
    activated: function() {
      console.log(' 激活');
      this.init_view();
    },
    methods: {
      init_view: function() {
        var that = this;
        // console.log('检测传参结果=' + this.check_key);
        this.$nextTick(function() {

          that.fun_init();
        });
      },
      fun_init: function() {
        this.init_data = '';

        this.init_data = JSON.stringify({
        	"control": "px_data",
        	"title": "培训资料设置",
        	"isTwo": "0",
        	"isTwoDetail": "0",
        	"action_flag": "",
        	"isFileMain": "1",
        	"step": "0",
        	"sel_action": 'exp_px_study_set',
        	"upd_action": 'exp15_px_study_set',
        	"detail_part": "0",
        	"detail_excelup": "0",
        	"d_btn_more": "0",
        	"d_sel_action": '',
        	"d_upd_action": '',
        	"file_action": 'page_main',
        	"p1": 'wlgl',
        	"p2": 'help',
        	"p3": '',
        	"parm_sel": [
        		{
        			"name": "标题",
        			"val": "",
        			"key": "title",
        			"type": "text",
        			"class": "long1",
        			"sel": "1"
        		},
        		{
        			"name": "介绍",
        			"val": "",
        			"key": "pxdata",
        			"type": "text",
        			"class": "long1",
        			"sel": "2"
        		},
				{
					"name": "分类",
					"val": "",
					"key": "px_class",
					"type": "select",
					"class": "long1",
					"sel_action": "_base_pxclass",
					"sel_name": "",
					"sel": "3"
				}
        	],
        	"parm": [
        		{
        			"name": "标题",
        			"val": "",
        			"key": "page_title",
        			"type": "text",
        			"class": "long2",
        			"p": "1",
        			"w": "1",
        			"r": "0",
        			"x": "1"
        		},
				{
					"name": "分类",
					"val": "",
					"key": "page_class",
					"type": "select",
					"class": "long1",
					"sel_action": "_base_pxclass",
					"sel_name": "",
					"p": "1",
					"w": "1",
					"r": "0",
					"x": "1"
				},
        		{
        			"name": "介绍",
        			"val": "",
        			"key": "page_detail",
        			"type": "textareaedit",
        			"class": "long4",
        			"p": "1",
        			"w": '1',
        			"r": '0',
        			"x": "2"
        		},
				
        		{
        			"name": "备注",
        			"val": "",
        			"key": "note",
        			"type": "text",
        			"class": "long4",
        			"p": "1",
        			"w": "0",
        			"r": "0",
        			"x": "3"
        		}
        	],
        	"parm_th": [
        		{
        			"name": "序号"
        		},
				{
					"name": "标题"
				},
        		{
        			"name": "类型"
        		},
        		{
        			"name": "介绍"
        		},
        		
        		{
        			"name": "详情状态"
        		},
        		{
        			"name": "点击量"
        		},
        		{
        			"name": "备注",
        			"class": "long2"
        		},
        		{
        			"name": "状态"
        		},
        		{
        			"name": "修改人"
        		},
				{
					"name": "修改时间"
				},
        		// {
        		// 	"name": "路径1"
        		// },
        		// {
        		// 	"name": "路径2"
        		// }
        		
        	],
        	"d_parm": [
        	],
        	"d_name": [
        	]
        
        });
		

      },
      refresh_data: function() {
        var that = this;
        this.$nextTick(function() {
          that.$refs['mybase'].refresh_data();
        });
      },
      refresh_father: function(type, val, parm) {
      	switch (type) {
      		case 'father':
      			// 弹出修改明细，修改主窗口信息
      			// this.refresh_data();
      			break;
      		default:
      			// console.log('子组件刷新父组件传值=' + val);
      			this.row_id = val;
      			this.item = parm;
      			break;
      	}
      }

    }
  };
</script>
